/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react';

export default {
  title: 'HSBC traditional Chinese logo',
  viewBox: '0 0 474.5 141.7',
  svgContent: (
    <>
      <rect x="-141.7" y="-141.8" fill="none" width="765.4" height="425.2" />
      <polygon
        fill="#FFFFFF"
        points="212.6,0 70.9,0 0,70.9 70.9,141.7 212.6,141.7 283.5,70.9 "
      />
      <polygon fill="#DB0011" points="283.5,70.9 212.6,0 212.6,141.7 " />
      <polygon fill="#DB0011" points="141.7,70.9 212.6,0 70.9,0 " />
      <polygon fill="#DB0011" points="0,70.9 70.9,141.7 70.9,0 " />
      <polygon fill="#DB0011" points="141.7,70.9 70.9,141.7 212.6,141.7 " />
      <path d="M319.4,72.2l6.4-6.1c-3.9-4.6-8.2-8.9-13-12.6l-5.7,6.1C311.5,63.5,315.7,67.7,319.4,72.2z" />
      <path d="M315.8,111c4.7-9.4,8.4-19.4,11.1-29.6l-8-3.5c-2.1,9.9-5.9,19.3-11.1,27.9L315.8,111z" />
      <path d="M314.6,32.6l-5.4,6c4.6,3.5,8.8,7.5,12.5,11.9l6-6.4C323.8,39.8,319.4,36,314.6,32.6z" />
      <polygon points="337.9,42.1 386.6,42.1 386.6,34.9 329.3,34.9 329.3,109.1 386.6,109.1 386.6,101.8 337.9,101.8 " />
      <path
        d="M365,52.8h-10.9l0.2-0.5c1-1.9,1.8-3.9,2.6-5.9l-7.3-2.8c-2.4,7-6,13.6-10.4,19.6l3.2,8.6c0.9-0.9,1.7-1.9,2.4-3l0.6-1v31.4
	h8.2V97h30.2v-7.2h-12.8v-5.5h10v-6.9h-10V72h10v-6.9h-10v-5h12.7v-7.3h-14.3l3.6-2.9c-1.9-2.5-4.2-4.6-6.8-6.4l-5.7,4.8L365,52.8z
	 M362.9,89.9h-9.3v-5.5h9.3V89.9z M362.9,77.5h-9.3V72h9.3V77.5z M362.9,65.1h-9.3v-5h9.3V65.1z"
      />
      <polygon
        points="455,59 460.8,59 460.8,53.7 455,53.7 455,50 459.8,50 459.8,44.9 455,44.9 455,41.5 460.8,41.5 460.8,36.3 
	455,36.3 455,32.8 447.8,32.8 447.8,36.3 441.9,36.3 441.9,41.5 447.8,41.5 447.8,44.9 442.9,44.9 442.9,50 447.8,50 447.8,53.7 
	441.9,53.7 441.9,59 447.8,59 447.8,62.7 439.2,62.7 439.2,32.5 432,32.5 432,62.7 423.4,62.7 423.4,59 429.3,59 429.3,53.7 
	423.4,53.7 423.4,50 428.2,50 428.2,44.9 423.4,44.9 423.4,41.5 429.3,41.5 429.3,36.3 423.4,36.3 423.4,32.8 416.1,32.8 
	416.1,36.3 410.3,36.3 410.3,41.5 416.1,41.5 416.1,44.9 411.4,44.9 411.4,50 416.1,50 416.1,53.7 410.3,53.7 410.3,59 416.1,59 
	416.1,62.7 407.7,62.7 407.7,35.2 400.1,35.2 400.1,68.6 471.1,68.6 471.1,35.2 463.5,35.2 463.5,62.7 455,62.7 "
      />
      <rect x="397" y="72.3" width="77.2" height="5.9" />
      <path
        d="M454.4,102.7c1.1-1.6,2.2-3.4,3-5.1l0.1-0.2h8.5V81.9h-60.9v15.4h8.5l3.9,5.8h-21.2v5.9h78.3v-5.9H454L454.4,102.7z
	 M413.8,91.9v-4.4h43.5v4.4H413.8z M448.1,97.9c-1,1.9-2.1,3.6-3.5,5.2l-0.1,0.1h-17.3l-0.1-0.2c-0.8-1.5-1.8-3.2-3.1-5.2l-0.3-0.5
	h24.5L448.1,97.9z"
      />
    </>
  ),
};
